module.exports = __webpack_public_path__ + "img/EZ(2).cf286925.jpg";